<app-admin-header style="width: 100%;" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [stats]="[]"></app-admin-header>
<section class="container-fluid v4-bg-img py-5">
    <div class="container ms-pg-structure">
        <app-skelitions [hidden]="!skelition" [value]="2"></app-skelitions>
        <p-tabView class="v4-tabview" *ngIf="!skelition" [activeIndex]="activeTabIndex" (onChange)="onTabChange($event)">
            <p-tabPanel class="v4-tabview" header='{{"Upcoming"| translator}}' >
                <app-project-list *ngIf="!skelition"
                    [title]="'Upcoming'"
                    [activeIndex]="activeTabIndex" 
                    [projects]="upProjects" 
                    (projectDeleted)="ngOnInit()">
                </app-project-list>
            </p-tabPanel>
            <p-tabPanel header='{{"Current"| translator}}' >
                <app-project-list *ngIf="!skelition"
                    [title]="'Current'" 
                    [activeIndex]="activeTabIndex" 
                    [projects]="onProjects" 
                    (projectDeleted)="ngOnInit()">
                </app-project-list>
            </p-tabPanel>
            <p-tabPanel header='{{"Others"| translator}}' >
                <app-project-list *ngIf="!skelition"
                    [title]="'Others'" 
                    [activeIndex]="activeTabIndex" 
                    [projects]="othersProjects" 
                    (projectDeleted)="ngOnInit()">
                </app-project-list>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>
<!-- Confirm Modal -->
<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>
<app-footer></app-footer>